import { Button } from '@mui/material'
import NewIntegrationDialog from '../project-integrations/NewIntegrationDialog'
import useOverlay from '@/hooks/useOverlay'
import { QueryKey } from '@tanstack/react-query'
import { Add } from '@mui/icons-material'

type AddIntegrationButtonProps = {
  listQueryKey: QueryKey
}

export default function AddIntegrationButton({
  listQueryKey,
}: AddIntegrationButtonProps) {
  const addIntegrationOverlay = useOverlay()

  return (
    <>
      <Button
        variant="text"
        onClick={addIntegrationOverlay.open}
        startIcon={<Add />}
        sx={{ mt: 0.5, ml: 0.75 }}
        size="small"
      >
        Add Integration
      </Button>
      <NewIntegrationDialog
        overlay={addIntegrationOverlay}
        listQueryKey={listQueryKey}
      />
    </>
  )
}
